export default __webpack_public_path__ + "img/08d8e102296560561bbb014da64bdb3b.svg";